import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { SITE } from "@/content/site";

const EXPLORE_LINKS = [
  { label: "About Us", to: "/about" },
  { label: "Our Approach", to: "/our-approach" },
  { label: "Our People", to: "/our-people" },
  { label: "Start Your Journey", to: "/start-your-journey" },
];

const JOURNEY_LINKS = [
  { label: "All Journeys", to: "/journeys" },
  { label: "Tide Trails, Goa", to: "/journeys/tide-trails-goa" },
  { label: "Lessons from the Wild, Pench", to: "/journeys/lessons-from-the-wild-pench" },
  { label: "Coming Soon", to: "/journeys/coming-soon" },
  { label: "Bespoke Experiences", to: "/journeys/bespoke-experiences" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-pinedeep text-canvas" data-testid="site-footer">
      <div className="container-x grid gap-12 py-16 sm:py-20 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <p className="font-serif text-2xl font-medium tracking-tight">{SITE.name}</p>
          <p className="mt-3 font-serif italic text-lg text-canvas/70">{SITE.tagline}</p>
        </div>
        <nav aria-label="Footer exploration links">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#CFC286]">Explore</p>
          <ul className="mt-5 space-y-3">
            {EXPLORE_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-[15px] text-canvas/80 transition-colors hover:text-canvas"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Footer journey links">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#CFC286]">Journeys</p>
          <ul className="mt-5 space-y-3">
            {JOURNEY_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  data-testid={`footer-journey-${link.label.toLowerCase().replace(/\s+/g, "-").replace(/,/g, "")}`}
                  className="text-[15px] text-canvas/80 transition-colors hover:text-canvas"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#CFC286]">Contact</p>
          <a
            href={SITE.phoneHref}
            data-testid="footer-phone-link"
            className="mt-5 inline-flex items-center gap-2 text-[15px] text-canvas/80 transition-colors hover:text-canvas"
          >
            <Phone className="h-4 w-4" aria-hidden="true" />
            {SITE.phone}
          </a>
          <a
            href={SITE.emailHref}
            data-testid="footer-email-link"
            className="mt-3 inline-flex items-center gap-2 text-[15px] text-canvas/80 transition-colors hover:text-canvas"
          >
            <Mail className="h-4 w-4" aria-hidden="true" />
            {SITE.email}
          </a>
        </div>
      </div>
      <div className="border-t border-canvas/15">
        <div className="container-x flex flex-col gap-2 py-6 text-sm text-canvas/60 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {year} {SITE.legalName}. All rights reserved.
          </p>
          <p>{SITE.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
